import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { combine, reducerRegistry, sagaRegistry } from 'coral-utility';
import instrumentSliceReducer, {
  instrumentSliceSaga,
  InstrumentSliceState,
} from 'state/slices/instrument';
import { NotificationState } from 'state/ducks/notifications/types';
import NotificationReducer from 'state/ducks/notifications/reducer';

const sagaMiddleware = createSagaMiddleware();

/**
 * Add Default Reducers or Sagas that you want
 * to be included in the initial bundle.js
 */

reducerRegistry.register('instrumentSlice', instrumentSliceReducer);
reducerRegistry.register('notifications', NotificationReducer);

export type RootState = {
  instrumentSlice: InstrumentSliceState;
  notifications: NotificationState;
};

const reducer = combine(reducerRegistry.getReducers());
//TODO: only composeWithDevTools if dev in env
const store = configureStore({
  reducer: { ...reducer },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ thunk: false }).concat(logger, sagaMiddleware),
  devTools: true,
});

reducerRegistry.setChangeListener((reducers: any) => {
  store.replaceReducer(combine(reducers));
});

sagaRegistry.setChangeListener((sagas: any) => {
  sagaMiddleware.run(sagas);
});

sagaRegistry.register('instrument-slice-saga', instrumentSliceSaga);

export default store;
